<!--
 * @Description: 顶部导航栏
 * @Author: F-Stone
 * @LastEditTime: 2025-08-21 10:49:48
-->
<template>
  <section
      :class="$style['site-nav']"
      ref="siteNavRef"
      :data-nav-size="navSizeState"
      :data-nav-open-state="foldNavOpenState"
  >
    <div :class="$style['m-container']" class="u-wrapper--limit-width u-wrapper--limit-width--extra">
      <div :class="$style['m-container--inner']" class="flex items-center justify-between">
        <div :class="$style['state--pos-left']" class="flex items-center">
          <div :class="$style['site-logo']" :data-direction-logo="language === 'fa' ? 'right' : 'left'" class="pointer" @click="goIndex">
            <h1 class="u-hide">SUPER EX</h1>
            <img class="u-hide" src="https://static.spex.ltd/static/images/index/share-logo.png" title="SUPER EX"
                 alt="logo"/>
            <UtilSiteLogo :isPureColor="true"/>
          </div>
          <nav :class="$style['site-nav--list']" class="flex items-center">
            <!-- NOTE data-is-active 表示激活导航位置，此处的判断条件仅用于测试 -->
            <div
                v-for="(item, index) in navList"
                :class="$style['site-nav--item']"
                :key="index"
                class="flex items-center"
                :data-is-active="false"
                :data-is-more="item.isMore || undefined"
            >
              <div :class="$style['item-inner']">
                <component
                    :class="$style['item-text']"
                    class="flex items-center"
                    :is="'div'"
                    @click="handleClick(item)"
                >
                  <span :class="$style['text']">{{ item.title }}</span>&nbsp;
                  <i v-if="item.subnav || item.isMore" class="ueicon-arrow-down" :class="$style['ic']"></i>
                </component>
              </div>
              <UtilMoreSubnavPanel
                  v-if="item.isMore"
                  :class="[$style['subnav-panel'], $style['subnav-panel--more']]"
                  :groups="moreNavGroups"
                  @navigate="handleNavItem"
              />
              <UtilSubnavPanel v-else-if="item.subnav" :class="$style['subnav-panel']" :data="item.subnav"/>
            </div>
          </nav>
        </div>
        <div :class="$style['state--pos-right']">
          <div :class="$style['site-oper--group']" class="flex items-center">
            <div :class="[$style['btn--group'], $style['btn--group--user']]" class="flex items-center">
              <template v-if="!token">
                <div :class="$style['btn-item']">
                  <button :class="[$style['btn--login'], $style['btn']]" @click="login">
                    <span class="text">{{ $t('nav_oper.login') }}</span>
                  </button>
                </div>
                <div :class="$style['btn-item']">
                  <button :class="[$style['btn--register'], $style['btn']]" @click="register">
                    <span class="text">{{ $t('nav_oper.register') }}</span>
                  </button>
                </div>
              </template>
              <template v-else>
                <div :class="$style['btn-item']">
                  <button :class="[$style['btn--recharge'], $style['btn']]" @click="goChargemoney">
                    <span class="text">{{ $t('nav_oper.recharge') }}</span>
                  </button>
                </div>
                <div :class="$style['btn-item']">
                  <button :class="[$style['btn--assets'], $style['btn']]" @click="goAssets">
                    <span class="text">{{ $t('nav_oper.assets') }}</span>
                  </button>
                  <UtilAssetsPanel :class="$style['subnav-panel']"/>
                </div>
              </template>
            </div>
            <div :class="$style['btn--group']" class="flex items-center">
              <template v-if="token">
                <button :class="$style['icon-btn']" data-type="user">
                  <div :class="$style['icon-box']">
                    <i class="ueicon-user" :class="$style['ic']"></i>
                  </div>
                  <UtilUserPanel :class="$style['subnav-panel']"/>
                </button>
                <button :class="$style['icon-btn']" data-type="notice" @click="goZendesk">
                  <div :class="$style['icon-box']">
                    <i class="ueicon-notice" :class="$style['ic']"></i>
                  </div>
                  <!--                  <div :class="$style['counter']">-->
                  <!--                    <span :class="$style['text']">{{ transferNoticeNumber(unreadNum) }}</span>-->
                  <!--                  </div>-->
                </button>
              </template>
              <button :class="$style['icon-btn']" data-type="download">
                <div :class="$style['icon-box']">
                  <i class="ueicon-download" :class="$style['ic']"></i>
                </div>
                <UtilAppDownloadQRCode qrcodeID="qrcodeHeader" :class="$style['panel--qrcode']"/>
              </button>
              <button :class="$style['icon-btn']" data-type="locale" @click="showLocalSwitchPanel = true">
                <div :class="$style['icon-box']">
                  <i class="ueicon-globe" :class="$style['ic']"></i>
                </div>
              </button>
              <button
                  :class="$style['icon-btn']"
                  @click="changeTheme"
                  data-type="styleType"
              >
                <div :class="$style['icon-box']">
                  <i :class="[$style['ic'],{'ueicon-sun': styleType === 'moon','ueicon-moon': styleType === 'sunlight',},]"></i>
                </div>
              </button>
              <button
                  :class="[$style['icon-btn'], $style['btn--fold-nav']]"
                  class="flex items-center justify-center"
                  @click="toggleFoldNav"
              >
                <div :class="$style['btn--inner']">
                  <div :class="$style['line']" :style="{ '--delay': 1 }"></div>
                  <div :class="$style['line']" :style="{ '--delay': 2 }"></div>
                  <div :class="$style['line']" :style="{ '--delay': 3 }"></div>
                </div>
              </button>
            </div>
          </div>
        </div>
        <!-- NOTE 折叠导航，在 1440px 以下显示，用于导航在小屏幕下无法完整显示的情况 -->
        <transition :css="false" @enter="onEnter" @leave="siteFoldNavLeave">
          <SiteFoldNav
              v-if="foldNavOpenState"
              :class="$style['site-fold-nav']"
              ref="foldNavRef"
              :style-type="styleType"
              :link-url="linkUrl"
              :language="language"
              @close="foldNavOpenState = false"
              @navigate="handleNavItem"
              @login="login"
              @register="register"
              @open-language="showLocalSwitchPanel = true"
              @change-theme="changeTheme"
              @set-theme="setTheme"
              @notice="goZendesk"
          />
        </transition>
      </div>
    </div>
    <Transition :css="false" @enter="enter" @leave="leave">
      <SiteLocalSwitchPanel
          v-if="showLocalSwitchPanel"
          ref="localSwitchPanel"
          @close="showLocalSwitchPanel = false"
      />
    </Transition>
  </section>
</template>
<script>
import {mapGetters} from 'vuex'
import UtilUserPanel from '@/components/util/UserPanel.vue'
import UtilAppDownloadQRCode from '@/components/util/AppDownloadQRCode.vue'
import SiteFoldNav from '@/components/layout/SiteFoldNav.vue'
import UtilSubnavPanel from '@/components/util/SubnavPanel.vue'
import UtilMoreSubnavPanel from '@/components/util/MoreSubnavPanel.vue'
import UtilSiteLogo from '@/components/util/SiteLogo.vue'
import UtilAssetsPanel from '@/components/util/AssetsPanel.vue'
import SiteLocalSwitchPanel from "@/components/layout/SiteLocalSwitchPanel.vue";
import {useSiteNav} from '../plugins/use-site-nav.js'
import {setCookie} from '../utils/common'
import {gsap, lenis} from "../utils/gsap";
import {unreadList} from '../apis/user';
import {checkIsAgentState} from '@/apis/agent.js'
import urls from "@/utils/baseUrl";
import {buildMainSiteUrl, navigateNavItem} from '@/utils/navigate-nav-item'
export default {
  name: 'SiteNav',
  components: {
    UtilUserPanel,
    UtilAppDownloadQRCode,
    SiteFoldNav,
    UtilSubnavPanel,
    UtilMoreSubnavPanel,
    UtilSiteLogo,
    UtilAssetsPanel,
    SiteLocalSwitchPanel
  },
  data() {
    const {navList, moreNavList, moreNavGroups} = useSiteNav();
    return {
      moreNavList,
      moreNavGroups,
      navList,
      navSizeState: 'normal',
      foldNavOpenState: false,
      unreadNum: 0,
      showLocalSwitchPanel: false,
      linkUrl: urls.linkUrl,
    };
  },
  computed: {
    ...mapGetters(['styleType', 'token', 'language', 'userInfo', 'invitationCode'])
  },
  mounted() {
    this.setNavSizeState();
    window.removeEventListener('scroll', this.setNavSizeState);
    window.addEventListener('scroll', this.setNavSizeState);
    window.addEventListener('resize', this.onResize);
  },
  created() {
  },
  beforeDestroy() {
    if (this.$refs.siteNavRef) {
      this.$refs.siteNavRef.setAttribute('data-nav-size', 'normal');
    }
    window.removeEventListener('scroll', this.setNavSizeState);
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    enter(el, done) {
      const panel = this.$refs.localSwitchPanel;
      if (!panel || typeof panel.show !== 'function') {
        if (typeof done === 'function') done();
        return;
      }
      panel.show().then(done).catch(() => {
        if (typeof done === 'function') done();
      });
    },
    leave(el, done) {
      const panel = this.$refs.localSwitchPanel;
      if (!panel || typeof panel.hide !== 'function') {
        if (typeof done === 'function') done();
        return;
      }
      panel.hide().then(done).catch(() => {
        if (typeof done === 'function') done();
      });
    },
    goZendesk() {
      window.open(this.language == 'zh-TC' ? 'https://support.superex.com/hc/zh-hk/categories/4410470420249' : this.language == 'ko' ? 'https://support.superex.com/hc/ko/categories/4410470420249' : 'https://support.superex.com/hc/en-001/categories/4410470420249')
    },
    changeTheme() {
      this.setTheme(this.styleType === 'sunlight' ? 'moon' : 'sunlight')
    },
    setTheme(mode) {
      if (!mode || this.styleType === mode) return
      this.$store.dispatch('setStyleType', mode)
      setCookie('styleType', mode)
      window.document.documentElement.setAttribute('data-theme', mode)
      if (this.commonStore) {
        this.commonStore.setGlobalState({qiankunState: {styleType: mode}})
      }
    },
    goChargemoney() {
      window.location.href = buildMainSiteUrl(this.linkUrl, '/wallet/chargemoney', this.language)
    },
    goAssets() {
      window.location.href = buildMainSiteUrl(this.linkUrl, '/consolidation/walletotal', this.language)
    },
    handleNavItem(item) {
      this.$store.dispatch('setGridType', item.tradeGroud ? 'grid' : item.tradeStock ? 'stock' : 'trade')
      navigateNavItem(item, {
        router: this.$router,
        linkUrl: this.linkUrl,
        token: this.token,
        invitationCode: this.invitationCode,
        language: this.language,
      })
    },
    handleClick(item) {
      if (item.isMore || item.subnav) {
        return
      }
      this.handleNavItem(item)
    },
    goAgent() {
      if (!this.token) {
        window.location.href = buildMainSiteUrl(this.linkUrl, '/agentSystem/agentHome', this.language)
        return
      }
      checkIsAgentState().then((res) => {
        this.agentStatus = res.data.status
        console.log(res, '200了哦')
        if (this.agentStatus === 1) {
          window.location.href = buildMainSiteUrl(this.linkUrl, '/agentSystem/dataBoard', this.language)
        } else {
          window.location.href = buildMainSiteUrl(this.linkUrl, '/agentSystem/agentHome', this.language)
        }
      }).catch((err) => {
        console.log(err.code, '返回了500哦')
        window.location.href = buildMainSiteUrl(this.linkUrl, '/agentSystem/agentHome', this.language)
      })
    },
    login() {
      const loginUrl = buildMainSiteUrl(this.linkUrl, '/login', this.language)
      if (this.$route.path == '/affiliates') {
        const currentQuery = {...this.$route.query, isAffiliates: '1'}
        const query = new URLSearchParams(currentQuery).toString()
        window.location.href = query ? `${loginUrl}?${query}` : loginUrl
        return
      } else {
        window.location.href = loginUrl
      }
    },
    register() {
      const registerUrl = buildMainSiteUrl(this.linkUrl, '/register', this.language)
      if (this.$route.path == '/affiliates') {
        const currentQuery = {...this.$route.query, isAffiliates: '1'}
        const query = new URLSearchParams(currentQuery).toString()
        window.location.href = query ? `${registerUrl}?${query}` : registerUrl
        return
      } else {
        window.location.href = registerUrl
      }
    },
    goIndex() {
      window.location.href = buildMainSiteUrl(this.linkUrl, '/index', this.language)
    },
    setNavSizeState() {
      const scrollH = window.scrollY;
      if (scrollH > 10) {
        if (this.navSizeState !== 'mini') {
          this.navSizeState = 'mini';
        }
      } else if (this.navSizeState !== 'normal') {
        this.navSizeState = 'normal';
      }
    },
    transferNoticeNumber(num) {
      return num > 99 ? '99+' : num;
    },
    // 通知数量
    unreadList() {
      unreadList().then((res) => {
        if (res.data) {
          this.unreadNum = res.data.num
        }
      })
    },
    onClickOut(ev) {
      const foldRef = this.$refs.foldNavRef;
      if (ev.target instanceof HTMLElement && foldRef && ev.target.closest(`.${foldRef.$el.classList[0]}`)) {
        return;
      }
      this.closeFoldNav();
    },
    toggleFoldNav(ev) {
      ev.stopPropagation();
      if (this.foldNavOpenState) {
        this.closeFoldNav();
      } else {
        this.openFoldNav();
      }
    },
    openFoldNav() {
      if (lenis && typeof lenis.stop === 'function') {
        lenis.stop();
      }
      this.foldNavOpenState = true;
      document.body.addEventListener('click', this.onClickOut);
    },
    closeFoldNav() {
      if (lenis && typeof lenis.start === 'function') {
        lenis.start();
      }
      this.foldNavOpenState = false;
      document.body.removeEventListener('click', this.onClickOut);
    },
    onEnter(el, done) {
      if (!(el instanceof HTMLElement)) return;
      if (gsap && typeof gsap.fromTo === 'function') {
        gsap.fromTo(el, {y: 10, opacity: 0}, {duration: 0.36, y: 0, opacity: 1, onComplete: done});
      } else {
        done();
      }
    },
    siteFoldNavLeave(el, done) {
      if (!(el instanceof HTMLElement)) return;
      if (gsap && typeof gsap.to === 'function') {
        gsap.to(el, {duration: 0.36, y: 10, opacity: 0, onComplete: done});
      } else {
        done();
      }
    },
    onResize() {
      this.closeFoldNav();
    }
  },
};
</script>
<style lang="scss" module>
@import "../assets/css/scss-utils/scss/abstracts/mixins";
@import "../assets/css/scss-utils/scss/abstracts/_breakpoint";
@import "../assets/css/variable";
@import "../assets/css/mixin";
@import "../assets/css/var";

:global(html[data-theme="sunlight"]) {
  .site-nav {
    .site-oper--group {
      .icon-btn {
        &:hover .icon-box {
          background: #f6f6f6;
        }
      }

      .btn {
        color: color(var(--font-color), 1);
      }
    }
  }
}

.site-nav {
  --nav-height: 60px;
  position: sticky;
  z-index: 1100;
  top: 0;
  width: 100%;
  transition: var(--transition-theme-color);
  transition-property: background-color, box-shadow;
  background-color: color(var(--site-background-color), 1);
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0);

  &[data-nav-size="mini"] {
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
  }

  &[data-nav-open-state="true"] {
    .site-oper--group {
      .btn--fold-nav {
        --line-distance: 0;
        --rotate: 45deg;

        .line {
          &:nth-child(2) {
            opacity: 0;
          }
        }
      }
    }
  }

  .m-container {
    width: 100%;
    box-sizing: border-box;
  }

  .m-container--inner {
    position: relative;
    width: 100%;
    height: var(--nav-height);
  }

  .state--pos-left {
    flex: 1;
    min-width: 0;
  }

  .state--pos-right {
    flex-shrink: 0;
    margin-left: auto;
  }

  .site-logo {
    @include image-placeholder(142, 28);
    flex: 0 0 142px;
    width: 142px;
    min-width: 142px;
    &[data-direction-logo='left'] {
      margin-right: 30px;
    }
    &[data-direction-logo='right'] {
      margin-left: 30px;
    }
  }

  .site-service-nav {
    &[data-direction='left'] {
      margin-right: 58px;
    }
    &[data-direction='right'] {
      margin-left: 58px;
    }
  }

  .subnav-panel {
    --dis-y: 10px;
    position: absolute;
    top: 100%;
    left: 50%;

    visibility: hidden;

    transition: 0.26s ease;
    transform: translate3d(-50%, var(--dis-y), 0);

    opacity: 0;
  }

  .subnav-panel--more {
    left: 50%;
    right: auto;
    transform: translate3d(-50%, var(--dis-y), 0);
  }

  .site-nav--list {
    font-size: 14px;
    font-weight: 500;
    line-height: 160%; /* 22.4px */

    gap: 18px;
  }

  .site-nav--item {
    position: relative;

    height: var(--nav-height);
    color: rgba(var(--font-color), 1);
    cursor: pointer;
    transition: var(--transition-theme-color);

    .ic {
      font-size: em(20px, 14px);

      display: block;

    }

    .text {
      color: rgba(var(--font-color), 1);
    }

    &:hover,
    &[data-is-active="true"] {
      color: color(var(--theme-color), 1);

      .ic {
        transform: rotate(180deg);
      }

      .text {
        color: color(var(--theme-color), 1);
      }
    }

    &:hover {
      .subnav-panel {
        --dis-y: 0;
        visibility: visible;

        opacity: 1;
      }
    }

    &[data-is-more="true"] {
      .subnav-panel--more {
        left: 50%;
        right: auto;
        transform: translate3d(-50%, var(--dis-y), 0);
      }
    }
  }

  .site-oper--group {
    gap: 16px;

    .btn--group {
      gap: 8px;
    }

    .btn-item {
      position: relative;

      display: flex;

      height: var(--nav-height);

      cursor: pointer;

      align-items: center;

      &:hover {
        .subnav-panel {
          --dis-y: 0;
          visibility: visible;

          opacity: 1;
        }
        .btn--chain{
          color: color(var(--theme-color), 1);
          border: 1px solid color(var(--theme-color), 1);
          .ic{
            transform: rotate(180deg);
          }
        }
      }
    }

    .btn {
      font-size: 13px;
      font-weight: 500;
      line-height: 140%; /* 18.2px */
      font-family: "PingFang SC";

      padding: em(6px, 13px) em(16px, 13px);

      transition: var(--transition-theme-color);

      color: color(var(--font-color));
      border-radius: em(6px, 13px);
    }

    .btn--login,
    .btn--recharge,
    .btn--register {
      &:hover {
        color: color(var(--font-color));
      }
    }

    .btn--recharge,
    .btn--register {
      border: 2px solid color(var(--font-color),0.6);
    }
    .btn--chain{
      border: 1px solid color(var(--font-color),0.05);
      border-radius: 20px;
      .ic{
        font-size: em(18px, 14px);
      }
    }
    .btn--assets,
    .btn--wallet {
      color: color(var(--font-color--inverted), 1);
      border: 2px solid color(var(--theme-color), 1);
      background: color(var(--theme-color), 1);
    }

    .icon-btn {
      font-size: 24px;
      padding: 0.25em 0.15em;
      position: relative;

      display: flex;

      cursor: pointer;

      align-items: center;
      justify-content: center;

      &:hover {
        .icon-box {
          color: color(var(--theme-color), 1);
          background: color(var(--font-color), 0.1);
        }

        .subnav-panel {
          --dis-y: 0;
          visibility: visible;

          opacity: 1;
        }
      }

      .icon-box {
        display: flex;
        width: 32px;
        height: 32px;
        transition: var(--transition-theme-color);
        border-radius: 1000px;
        align-items: center;
        justify-content: center;
        &[data-icon-type="walletAddress"]{
          display: flex;
          width: max-content;
          height: 36px;
          padding: 6px 12px;
          font-size: 14px;
          justify-content: center;
          align-items: center;
          gap: 8px;
          font-weight: 600;
          border-radius: 20px;
          border: 1px solid #D9A31A;
          background: color(var(--font-color), 0.05);
          color: color(var(--font-color), 0.6);
          img{
            width: 22px;
            height: 22px;
            border-radius: 50%;
          }
          &:hover{
            color: color(var(--theme-color), 1);
            background: color(var(--font-color), 0.1);
          }
        }
      }

      &[data-type="download"] {
        height: var(--nav-height);

        &:hover {
          .panel--qrcode {
            top: calc(100% + 10px);

            visibility: visible;

            opacity: 1;
          }
        }

        .panel--qrcode {
          position: absolute;
          z-index: 100;
          top: calc(100% + 20px);

          visibility: hidden;

          opacity: 0;
        }
      }

      &[data-type="user"] {
        height: var(--nav-height);
      }

      &[data-type="notice"] {
        .counter {
          font-size: 9px;
          font-weight: 700;
          line-height: em(10px, 9px);

          position: absolute;
          top: 0;
          left: calc(50% - 1px);

          padding: 2px 4px;

          transition: var(--transition-theme-color);

          color: #fff;
          border-radius: 100px;
          background-color: #ff4423;
          box-shadow: 0 0 0 2px color(var(--site-background-color));

          .text {
            display: block;

            transform: translateY(-0.04em);
          }
        }
      }
      &[data-type="styleType"] {
        &:hover{
          .icon-box {
            color: color(var(--theme-color), 1);
            background: color(var(--font-color), 0.1);
          }
        }
      }
    }

    .btn--fold-nav {
      @include square(32px);
      --line-distance: 6px;
      --rotate: 0deg;
      position: relative;

      display: none;

      cursor: pointer;

      .btn--inner {
        position: relative;

        width: 16px;
        height: 1.5px;

        pointer-events: none;
      }

      &:hover {
        color: color(var(--font-color), 1);

        .line {
          &::before,
          &::after {
            transition: 0.36s ease;
            transition-delay: calc(var(--delay) * 0.1s);
            transition-property: transform, opacity;
          }

          &::before {
            transform: translateX(0%);
          }

          &::after {
            transform: translateX(140%);
          }
        }
      }

      .line {
        --move-x: 0%;
        position: absolute;
        left: 0;

        overflow: hidden;

        width: 100%;
        height: 100%;

        transition: var(--transition-theme-color);

        border-radius: 4px;

        &:first-child {
          top: var(--line-distance);

          transform: rotate(calc(var(--rotate) * -1));
        }

        &:nth-child(2) {
          top: 0;
        }

        &:last-child {
          bottom: var(--line-distance);

          transform: rotate(var(--rotate));
        }

        &::before,
        &::after {
          @include ab-cover;
          content: "";
          transition: 0.36s ease;
          transition-property: background-color;

          border-radius: inherit;
          background-color: currentColor;
        }

        &::before {
          transform: translateX(-120%);
        }
      }
    }
  }

  .site-fold-nav {
    position: absolute;
    z-index: 1000;
    top: 100%;
    right: 0;
  }
}

@include media-breakpoint-down(xxxxxl) {
  .site-nav {
    .site-nav--list {
      gap: 18px;
    }
    .site-service-nav {
      &[data-direction='left'] {
        margin-right: 50px;
      }
      &[data-direction='right'] {
        margin-left: 50px;
      }
    }
  }
}

@include media-breakpoint-down(xxxxl) {
  .site-nav {
    .site-nav--list {
      gap: 18px;
    }

    .site-service-nav {
      &[data-direction='left'] {
        margin-right: 40px;
      }
      &[data-direction='right'] {
        margin-left: 40px;
      }
    }

    .site-nav--item {
      .ic {
        font-size: em(18px, 14px);
      }
    }
  }
}

@include media-breakpoint-down(xxxl) {
  .site-nav {
    .site-logo {
      width: 142px;
      &[data-direction-logo='left'] {
        margin-right: 15px;
      }
      &[data-direction-logo='right'] {
        margin-left: 15px;
      }
    }

    .site-nav--list {
      font-size: 13px;

      gap: 18px;
    }

    .site-service-nav {
      &[data-direction='left'] {
        margin-right: 20px;
      }
      &[data-direction='right'] {
        margin-left: 20px;
      }
    }

    .site-oper--group {
      gap: 12px;

      .btn {
        font-size: 12px;
      }
    }

    .btn--service-nav {
      .dot-group {
        gap: 2px;
      }
    }
  }
}

@include media-breakpoint-down(xxl) {
  .site-nav {
    .site-logo {
      width: 142px;
      &[data-direction-logo='left'] {
        margin-right: 20px;
      }
      &[data-direction-logo='right'] {
        margin-left: 20px;
      }
    }

    .btn--service-nav {
      .dot-group {
        gap: 2px;
      }
    }
  }
}

/* ≤1200px：窄屏顶栏 + 抽屉 */
@media (max-width: 1200px) {
  .site-nav {
    width: 100vw;
    min-width: 0;

    .site-nav--list {
      display: none;
    }

    .site-oper--group {
      .btn--fold-nav {
        display: flex;
      }

      .icon-btn[data-type="notice"],
      .icon-btn[data-type="download"],
      .icon-btn[data-type="locale"],
      .icon-btn[data-type="styleType"] {
        display: none;
      }

      /* 贴触发按钮行内末端：LTR 右、RTL 左，避免视口边缘裁切 */
      .btn-item .subnav-panel,
      .icon-btn[data-type="user"] .subnav-panel {
        left: auto;
        right: auto;
        inset-inline-end: 0;
        transform: translate3d(0, var(--dis-y), 0);
      }
    }

    .site-fold-nav {
      position: fixed;
      z-index: 1200;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;

      :global(*) {
        pointer-events: auto;
      }
    }
  }
}

@include media-breakpoint-down(lg) {
  .site-nav {
    .site-logo {
      width: 142px;
    }

    .site-service-nav {
      display: none;
    }

    .site-oper--group {
      .btn--group {
        gap: 5px;
      }

    }

    .site-fold-nav {
      position: fixed;
      top: 0;
      left: 0;
    }
  }
}
</style>
